export default "__VITE_ASSET__BGwVM$JA__"